import { createRegistry } from '../createRegistry';
const registry = createRegistry({ host: 'corvid' });
export default registry;
export { registry };
export * from '../types';
//# sourceMappingURL=platform.js.map